import React, { useState, useEffect } from "react";
import classes from "./GenerateKey.module.css";
import urls from "../../Utils/urls";
import axios from "../../axios";
import { useSelector } from "react-redux";

function formatDate(dateString) {
  const [month, day, year] = dateString.split("/");
  const date = new Date(`${year}-${month}-${day}`);
  return date.toISOString();
}

function GenerateKey({ Close }) {
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedRole, setSelectedRole] = useState("");
  const [clientAccount, setClientAccount] = useState("");
  const [clientKey, setClientKey] = useState("");
  const [maxUse, setMaxUse] = useState("");
  const [validTill, setValidTill] = useState("");
  const [getAvailableRoles, setAvailableRoles] = useState(null);
  // const [getClientAccounts, setClientAccounts] = useState(null);
  // const [formData, setFormData] = useState({});

  const email = useSelector(
    (state) => state.RS_Authentication.user.details.email
  );
  const clientId = Math.floor(Math.random() * 10000) + 1;
  // Today's Date
  const today = new Date();
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const day = today.getDate().toString().padStart(2, "0");
  const year = today.getFullYear().toString();
  const dateString = `${month}/${day}/${year}`;
  const dateString1 = formatDate(dateString);
  // const isoDateStr = new Date(validTill).toISOString();

  const handleCheckboxChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleRoleChange = (event) => {
    setSelectedRole(+event.target.value);
  };

  useEffect(() => {
    axios
      .get(urls.admin.getAvailableRoles())
      .then((res) => {
        let data = res?.data?.items || [];
        setAvailableRoles(data);
      })
      .catch((error) => console.error(error));
    // axios
    //   .get(urls.dashboard.getRoleKeys())
    //   .then((res) => {
    //     let data = res.data.items;
    //     setClientAccounts(data);
    //   })
    //   .catch((error) => console.error(error));
  }, []);
  // const data = {
  //   selectedValue,
  //   selectedRole,
  //   clientKey,
  //   clientAccount,
  //   maxUse,
  //   validTill,
  // };
  // const data5 = {
  //   items: [
  //     {
  //       KEY_ID: 61,
  //       ROLE_ID: 1,
  //       CLIENT_ACCOUNT_TYPE: "L",
  //       CLIENT_KEY: "12345",
  //       MAX_USE: 5,
  //       VALID_TILL: "03/31/2023",
  //       CREATED: "03/08/2023",
  //       CREATED_BY: "DEV@SUPERIORLOANSERVICING.COM",
  //       UPDATED: "03/08/2023",
  //       UPDATED_BY: "DEV@SUPERIORLOANSERVICING.COM",
  //     },
  //   ],
  // };
  // const validTill2 = formatDate(validTill);
  const handleSubmit = (e) => {
    e.preventDefault();
    // const data2 = {
    //   KEY_ID: 10000,
    //   ROLE_ID: selectedRole,
    //   CLIENT_ACCOUNT_TYPE: selectedValue,
    //   CLIENT_KEY: clientKey,
    //   MAX_USE: maxUse,
    //   VALID_TILL: isoDateStr,
    //   CREATED: dateString1,
    //   CREATED_BY: email,
    //   UPDATED: dateString1,
    //   UPDATED_BY: email,
    // };

    // const data3 = {
    //   KEY_ID: 10,
    //   ROLE_ID: 1,
    //   CLIENT_ACCOUNT_TYPE: "L",
    //   CLIENT_KEY: "123456",
    //   MAX_USE: 4,
    //   VALID_TILL: "03/31/2023",
    //   CREATED: "03/08/2023",
    //   CREATED_BY: "DEV@SUPERIORLOANSERVICING.COM",
    //   UPDATED: "03/08/2023",
    //   UPDATED_BY: "DEV@SUPERIORLOANSERVICING.COM",
    // };

    // const data2 = {
    //   items: [
    //     {
    //       KEY_ID: 10000,
    //       ROLE_ID: 2,
    //       CLIENT_ACCOUNT_TYPE: "C",
    //       CLIENT_KEY: 2,
    //       MAX_USE: 1234,
    //       VALID_TILL: "2023-01-24T14:53:26Z",
    //       CREATED: "2023-01-24T14:53:26Z",
    //       CREATED_BY: "test@test.com",
    //       UPDATED: "2023-01-24T14:53:26Z",
    //       UPDATED_BY: "test@test.com",
    //     },
    //   ],
    // };

    const data2 = {
      KEY_ID: clientId,
      ROLE_ID: selectedRole,
      CLIENT_ACCOUNT_TYPE: selectedValue,
      CLIENT_KEY: clientKey,
      MAX_USE: maxUse,
      VALID_TILL: validTill,
      CREATED: dateString1,
      CREATED_BY: email,
      UPDATED: dateString1,
      UPDATED_BY: email,
    };

    axios
      .post(urls.admin.postClientKey(), data2)
      .then((res) => {})
      .catch((err) => {});
  };

  return (
    <form
      style={{ backgroundColor: "#fff", fontSize: "14px" }}
      onSubmit={handleSubmit}
    >
      <h4 style={{ marginBottom: "28px" }}>Generate Keys</h4>
      <div
        className={`d-flex align-items-center ${classes.marginBottom_38} ${classes.gap_40}`}
      >
        <p style={{ margin: "0", width: "300px" }}>Client Account Type</p>
        <div
          className="d-flex align-items-center justify-content-between"
          style={{
            width: "100%",
            border: "1px solid #333",
            height: "35px",
            padding: "0px 10px",
            borderRadius: "2px",
          }}
        >
          <div>
            <input
              type="checkbox"
              id="option1"
              style={{ marginRight: "10px" }}
              value="C"
              checked={selectedValue === "C"}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="option1">SLS Servicing Employee</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="option2"
              style={{ marginRight: "10px" }}
              value="B"
              checked={selectedValue === "B"}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="option2">Borrower</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="option3"
              style={{ marginRight: "10px" }}
              value="L"
              checked={selectedValue === "L"}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="option3">Lender</label>
          </div>
          <div>
            <input
              type="checkbox"
              id="option3"
              style={{ marginRight: "10px" }}
              value="V"
              checked={selectedValue === "V"}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="option3">Broker</label>
          </div>
        </div>
      </div>
      <div className={classes.form}>
        <div
          className="d-flex align-items-center"
          style={{ gap: "40px", marginBottom: "38px" }}
        >
          <label style={{ width: "300px" }}>Role</label>
          <select
            name="roles"
            style={{ width: "100%" }}
            value={selectedRole}
            onChange={handleRoleChange}
          >
            <option value="">Select Role</option>
            {getAvailableRoles?.map((el, i) => (
              <option key={i * 100} value={el.role_id}>
                {el.role_name}
              </option>
            ))}
            {/* <option value="lender">Lender</option>
            <option value="borrower">Borrower</option>
            <option value="broker">Broker</option> */}
          </select>
        </div>
        <div
          className="d-flex align-items-center"
          style={{ gap: "40px", marginBottom: "38px" }}
        >
          <label style={{ width: "224.833px" }}>Client Account</label>
          <input
            type="text"
            value={clientAccount}
            onChange={(e) => {
              setClientAccount(e.target.value);
            }}
          />
          {/* <select
            name="Client Account"
            placeholder="Client Account"
            style={{ width: "100%" }}
            value={clientAccount}
            onChange={(e) => {
              setClientAccount(e.target.value);
            }}
          >
            <option value="">Select Client Account</option>

            {getClientAccounts?.map((el) => (
              <option key={el.account} value={el.account}>
                {el.account}
              </option>
            ))}
          </select> */}
        </div>
        <div
          className={`d-flex align-items-center ${classes.marginBottom_38} ${classes.gap_40}`}
        >
          <label style={{ width: "224.833px" }}>Client Key</label>
          <input
            type="text"
            value={clientKey}
            onChange={(e) => {
              setClientKey(+e.target.value);
            }}
          />
        </div>
        <div
          className={`d-flex align-items-center ${classes.marginBottom_38} ${classes.gap_40}`}
        >
          <label style={{ width: "224.833px" }}>Max Use</label>
          <input
            type="text"
            value={maxUse}
            onChange={(e) => {
              setMaxUse(+e.target.value);
            }}
          />
        </div>
        <div
          className={`d-flex align-items-center ${classes.marginBottom_38} ${classes.gap_40}`}
        >
          <label style={{ width: "224.833px" }}>Valid Till</label>
          <input
            type="date"
            value={validTill}
            onChange={(e) => {
              // new Date(e.target.value).toISOString();
              setValidTill(e.target.value);
              // setValidTill(new Date(e.target.value).toISOString());
            }}
          />
        </div>
        <div
          className={`d-flex justify-content-end ${classes.marginBottom_38} ${classes.gap_20}`}
          style={{ marginRight: "20px" }}
        >
          <button
            className={`btn btn-outline py-3 px-4 ${classes.button}`}
            onClick={() => {
              Close();
            }}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary text-white btn-outline py-3 px-4"
            type="submit"
          >
            Create
          </button>
        </div>
      </div>
    </form>
  );
}

export default GenerateKey;
